module.exports = __webpack_public_path__ + "braveuistatic/img/apps/www.bravenet.com/src/assets/img/shared/bravenet-footer-logo.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/shared/bravenet-footer-logo.png
// module id = y1YT
// module chunks = 0